export default __webpack_public_path__ + "static/media/29.6fe8f25d.jpg";